import { allEnumValues, UserRight, UserRightHelper } from '@biteinc/enums';
export const userRoleSchema = {
    displayName: 'role',
    type: 'object',
    fields: {
        name: {
            type: 'keyString',
            required: true,
        },
        rights: {
            type: 'array',
            elementType: 'int',
            elementValues: allEnumValues(UserRight).filter((right) => {
                return !(UserRightHelper.isApiRight(right) ||
                    UserRightHelper.isBiteRight(right) ||
                    UserRightHelper.isApiTokenRight(right));
            }),
            required: true,
            minCount: 1,
            ui: 'extended-checklist',
        },
        orgId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
    },
};
//# sourceMappingURL=user_role_schema.js.map